import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { PowerUpDetailView } from '@/components';
import { usePowerUpDetail } from '@/lib/power-ups';

export const Route = createFileRoute('/power-ups/$powerUpId')({
  component: PowerUpDetailRoute,
});

function PowerUpDetailRoute(): ReactElement {
  const { powerUpId } = Route.useParams();
  const detail = usePowerUpDetail(powerUpId, true);

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
      <PowerUpDetailView
        powerUp={detail.data ?? null}
        loading={detail.isPending}
        error={detail.error?.message}
        onRetry={() => void detail.refetch()}
      />
    </div>
  );
}
